<script>
  import { onMount } from 'svelte';
  import { MDCTextField } from '@material/textfield';
  import { fly } from 'svelte/transition';

  export let id;
  export let label;
  export let value;
  export let disabled = false;
  export let variant = 'outlined';
  export let valid = true;
  export let invalid_text;
  export let selecting = false;
  export let name;
  export let active_id;
  export let is_15_minutes_scale = false;
  export let default_val = false;

  let text_field;
  let has_init = false;
  let has_field_init = false;
  let focus = false;
  let mouse_over = false;
  let hours = [];
  let minutes = [];
  let selected_hour = 7;
  let selected_min = 0;
  let has_values_init = false;

  const init_selector = () => {
    let element = document.getElementById(`${id}-time`);
    text_field = new MDCTextField(element);


    document.getElementById(id).addEventListener('keydown', (e) => {
      if (e.keyCode == 8) {
        value = '';
        selected_hour = 0;
        selected_min = 0;
        e.preventDefault();
      }
    });

    window.addEventListener('click', () => {
      let input = document.getElementById(`${id}-time`);
      if(!!input) selecting = input.classList.contains('mdc-text-field--focused');

    });

    init_values();

    has_init = true;
  };

  const init_values = () => {
    if(!is_15_minutes_scale){
      for (let i = 7; i < 24; i++) {
        hours.push(i);
      }
      for (let i = 0; i < 7; i++) {
        hours.push(i);
      }
    } else{
      for (let i = 0; i < 24; i++) {
        hours.push(i);
      }
    }


    for (let i = 0; i < 60; i++) {
      if(!is_15_minutes_scale){
        minutes.push(i);
      } else{
        if(i % 15 === 0) minutes.push(i);
      }
    }
    has_values_init = true;
  }

  const select_hour = (hour) => {
    selected_hour = hour;
    let tmp_hour = selected_hour;
    let tmp_min = selected_min;
    if (tmp_hour < 10) tmp_hour = `0${tmp_hour}`;
    if (tmp_min < 10) tmp_min = `0${tmp_min}`;
    value = `${tmp_hour}:${tmp_min}`;
  };

  const select_min = (min) => {
    selected_min = min;
    let tmp_hour = selected_hour;
    let tmp_min = selected_min;
    if (tmp_hour < 10) tmp_hour = `0${tmp_hour}`;
    if (tmp_min < 10) tmp_min = `0${tmp_min}`;
    value = `${tmp_hour}:${tmp_min}`;
  };

  $: if (!!value && has_init && !has_field_init) {
    if(default_val){
      let time = value.split(':');
      select_hour(Number(time[0]));
      select_min(Number(time[1]));
    }
    has_field_init = true;
  }

  onMount(init_selector);
</script>

<div class='position-relative' id={id}>
  {#if variant === 'filled'}
    <label
      id={`${id}-time`}
      class:disabled-bg={disabled}
      class='mdc-text-field mdc-text-field--filled mdc-text-field--with-trailing-icon'
      class:mdc-text-field--invalid={!valid}
      class:mdc-text-field--disabled={disabled}
      class:mdc-text-field--label-floating={has_field_init}>
      <span class='mdc-text-field__ripple' />
      <span
        class='mdc-floating-label'
        id={`${id}-label`}
        class:mdc-floating-label--float-above={has_field_init}>
        {label}
      </span>
      <i
        class='material-icons mdc-text-field__icon mdc-text-field__icon--trailing'>schedule</i>

      <input
        readonly='readonly'
        id={`${id}-input`}
        class='mdc-text-field__input'
        type='text'
        autocomplete='off'
        {name}
        aria-labelledby={`${id}-label`}
        bind:value={value}
        {disabled} />
      <span class='mdc-line-ripple' />
    </label>
  {:else}
    <label
      id={`${id}-time`}
      class:disabled-bg={disabled}
      class='mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon'
      class:mdc-text-field--invalid={!valid}
      class:mdc-text-field--disabled={disabled}
      class:mdc-text-field--label-floating={has_field_init}>
      <span class='mdc-notched-outline'>
        <span class='mdc-notched-outline__leading' />
        <span class='mdc-notched-outline__notch'>
          <span
            class='mdc-floating-label'
            id={`${id}-label`}
            class:mdc-floating-label--float-above={has_field_init}>
            {label}
          </span>
        </span>
        <span class='mdc-notched-outline__trailing' />
      </span>
      <i class='material-icons mdc-text-field__icon'
         class:material-icons-disabled={disabled}>schedule</i>
      <input
        readonly='readonly'
        autocomplete='off'
        id={`${id}-input`}
        class='mdc-text-field__input'
        type='text'
        {name}
        aria-labelledby={`${id}-label`}
        bind:value={value}
        {disabled} />
    </label>
  {/if}

  {#if selecting}
    <div
      id={`${id}-options`}
      class='list-container'
      on:mouseover={() => mouse_over = true}
      on:mouseout={() => mouse_over = false}
      transition:fly={{ y: -50, duration: 250 }}
      class:container-style-outlined={variant === 'outlined'}
      class:container-style-filled={variant === 'filled'}
      class:container-style-filled-valid={variant === 'filled' && valid}
      class:container-style-outlined-invalid={variant === 'outlined' && !valid}
      class:container-style-filled-invalid={variant === 'filled' && !valid}>
      <div class='mdc-layout-grid' style='margin: 0; padding: 0;'>
        <div class='mdc-layout-grid__inner'>
          <div class='mdc-layout-grid__cell' style='overflow: scroll; height: 280px; width: 90px'>
            {#each hours as hour}
              <div class:time-block={selected_hour !== hour}
                   class:time-block-active={selected_hour === hour}
                   on:click={() => select_hour(hour)}>
                {#if hour < 10}
                  0{hour}
                {:else}
                  {hour}
                {/if}
              </div>
            {/each}
          </div>
          <div class='mdc-layout-grid__cell' style='overflow: scroll; height: 280px; width: 90px'>
            {#each minutes as minute}
              <div class:time-block={selected_min !== minute}
                   class:time-block-active={selected_min === minute}
                   on:click={() => select_min(minute)}>
                {#if minute < 10}
                  0{minute}
                {:else}
                  {minute}
                {/if}
              </div>
            {/each}
          </div>
        </div>
      </div>
    </div>
  {/if}

  {#if !valid}
    <div class='tooltip-error'>
      <span
        class='tooltip-text tooltip-top'
        id={`${id}-invalid`}>{invalid_text}</span>
    </div>
  {/if}
</div>


<style>
    .time-block {
        padding: 10px;
        cursor: pointer;
        display: flex;
        justify-content: center;
    }

    .time-block:hover {
        background-color: rgba(0, 102, 153, 0.25);
    }

    .time-block-active {
        padding: 10px;
        background-color: rgba(0, 102, 153, 1);
        color: white;
        cursor: pointer;
        display: flex;
        justify-content: center;
    }

    .mdc-text-field--outlined .mdc-floating-label {
        background-color: white !important;
    }

    .calendar-box p {
        margin-top: 4.1px;
    }

    .mdc-button {
        min-width: 35px !important;
    }

    .disabled-day {
        cursor: default !important;
        color: #c4c4c4 !important;
    }

    .disabled-icon {
        cursor: default !important;
        color: #a3a3a3 !important;
    }

    .disabled-icon:hover {
        background-color: white !important;
    }


    .material-icons {
        cursor: pointer;
        border-radius: 5px;
    }

    .material-icons:hover {
        background-color: rgba(0, 102, 153, 0.25);
        border-radius: 5px;
    }

    .calendar-box {
        width: 25.7px;
        height: 25.7px;
        vertical-align: middle;
        text-align: center;
        display: table-cell;
        float: left;
        font-size: 10pt;
        border-radius: 5px;
    }

    .calendar-not_current {
        cursor: pointer;
    }

    .calendar-not_current:hover {
        background-color: rgba(0, 102, 153, 0.25);
    }

    .calender-current_day {
        background-color: #006699;
        color: white;
        cursor: pointer;
    }

    .calender-other-month {
        color: #a3a3a3;
        cursor: pointer;
    }

    .calender-other-month:hover {
        background-color: rgba(0, 102, 153, 0.25);
    }

    .calendar-table {
        width: 180px;
    }

    .material-icons {
        color: black;
    }

    .material-icons-disabled {
        color: #b1b1b1 !important;
    }

    input {
        cursor: text;
    }

    .disabled-bg {
        opacity: 0.5;
        transition: all 0.2s ease-in-out;
    }

    .mdc-text-field {
        width: inherit;
        transition: all 0.2s ease-in-out;
    }

    .mdc-text-field--with-trailing-icon.mdc-text-field--outlined
    .mdc-text-field__input {
        padding-right: 15px;
    }

    .mdc-text-field--with-trailing-icon .mdc-text-field__input {
        padding-right: 15px;
    }

    .position-relative {
        position: relative;
        width: inherit;
    }

    .tooltip-error {
        position: relative;
        font-size: 12px;
        top: -50px;
        z-index: 12;
    }

    .tooltip-error .tooltip-top {
        position: absolute;
        z-index: 1;
        bottom: 100%;
        left: 50%;
        right: 0;
    }

    .tooltip-error .tooltip-text {
        background-color: var(--invalid-color);
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 8px 8px;
    }

    .list-container {
        position: absolute;
        top: 57px;
        height: 280px;
        width: 99%;
        z-index: 10000;
        overflow-y: scroll;
        overflow-x: hidden;
        box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
        0 5px 8px 0 rgba(0, 0, 0, 0.14), 0 1px 14px 0 rgba(0, 0, 0, 0.12);
    }

    .container-style-outlined {
        background-color: white;
        border-radius: 5px;
    }

    .container-style-outlined-invalid {
        border: 2px solid var(--invalid-color);
    }

    .container-style-filled {
        background-color: #ececec;
        border-radius: 5px;
    }

    .container-style-filled-valid {
        border-bottom: 2px solid #006699;
    }

    .container-style-filled-invalid {
        border-bottom: 2px solid var(--invalid-color);
    }

    @media (max-width: 479px){
        .mdc-layout-grid__inner {
            display: flex !important;
            min-width: max-content !important;
        }
    }


</style>